// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__vNH2S","Layout__main":"Layout_Layout__main__AFf8S"};